import { BankingValueObjectsCardTypeEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

export const cardShortTypeLabel = (card: { type: BankingValueObjectsCardTypeEnum }): string => {
  switch (card.type) {
    case 'physical':
      return i18n.t('expenses_v2.cards.type.short_physical')
    case 'virtual':
      return i18n.t('expenses_v2.cards.type.short_virtual')
    case 'single_use':
      return i18n.t('expenses_v2.cards.type.short_single_use')
    default:
      return card.type satisfies never
  }
}
